/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation LBRRoutePlanDeleteManyMutation($routePlanIds: [ID!] !) {
    LBRRoutePlanDeleteMany(routePlanIds: $routePlanIds){
      message
      status
    }
  }
`

